import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Panel } from "./PageParts";
import { api, errorMessage } from "@/lib/api";

const OPTIONS = [
  ["upcoming_email", "Upcoming deadline emails", "Sent at about 8am on the reminder date you choose for a confirmed deadline."],
  ["overdue_email", "Overdue alerts", "The day after a confirmed deadline is missed, then weekly for up to 4 weeks or until you mark it done."],
  ["daily_summary", "Daily summary", "One morning email listing confirmed deadlines that are overdue or due in the next 7 days."],
];

export const NotificationPrefs = () => {
  const [prefs, setPrefs] = useState(null);
  useEffect(() => { api.get("/me/notification-preferences").then(({ data }) => setPrefs(data.preferences)).catch((e) => toast.error(errorMessage(e))); }, []);

  const toggle = async (key, value) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    try { await api.put("/me/notification-preferences", next); toast.success("Notification preferences saved"); }
    catch (e) { setPrefs(prefs); toast.error(errorMessage(e)); }
  };

  return (
    <Panel title="Email notifications" testId="notification-prefs-panel">
      <div id="notifications" className="space-y-4 p-5">
        {prefs && OPTIONS.map(([key, label, help]) => (
          <label key={key} className="flex items-start justify-between gap-4">
            <span><span className="block text-sm font-medium text-navy">{label}</span><span className="block text-xs text-slate-500">{help}</span></span>
            <Switch checked={prefs[key]} onCheckedChange={(v) => toggle(key, v)} data-testid={`notify-${key}-switch`} />
          </label>
        ))}
        <p className="text-xs text-slate-500" data-testid="notification-prefs-note">These settings apply to all your workspaces. Only dates you've confirmed send reminders. Alerts also appear under the bell in the app. The sample workspace never sends email.</p>
      </div>
    </Panel>
  );
};
